import React, { useEffect } from "react";

import { applyResolvedLanguageFromSession } from "@/i18n";
import { useAccountSettingsBootstrapQuery } from "@/query/accountSettingsQuery";
import { useUserSessionStore } from "@/stores/v2/userSessionStore";

/**
 * Keeps i18next in sync with Account Settings `preferredLocale` (same cache as {@link useAccountSettingsBootstrapQuery}).
 * Mount inside `QueryClientProvider` and `I18nextProvider` — this component uses `useAccountSettingsBootstrapQuery` (see `index.tsx`).
 */
export function I18nLanguageSync({ children }: { children: React.ReactNode }): JSX.Element {
	const applianceId = useUserSessionStore((s) => s.active_device) ?? "";
	const { data: accountSettings } = useAccountSettingsBootstrapQuery(applianceId);

	useEffect(() => {
		void applyResolvedLanguageFromSession(accountSettings);
	}, [accountSettings]);

	return <>{children}</>;
}
